import targetSvg from '../../assets/summary-target.svg';
import { addCommas } from "../../utils/helpers";

interface SummaryCardProps {
    title: string;
    number: number;
    target: number;
    otherInfo?: string;
};

const SummaryCard = ({ title, number, target, otherInfo }: SummaryCardProps) => {
    // Calculate progress percentage
    const percentage = target !== 0 ? (number / target) * 100 : 0;

    return (
        <div className="w-full min-w-[11rem] max-w-[11.5rem] md:w-1/2 h-auto border border-solid border-titanium-white rounded-[3px] appearance-none">
            <h2 className="text-gotham-gray text-sm font-bold py-2 px-3 bg-at-white">{title}</h2>
            <div className="flex items-center mt-2 px-3">
                <h2 className="text-gotham-gray text-2xl mr-2 font-bold">{addCommas(number)}</h2>
                <img src={targetSvg} alt='target icon' className="ml-1 w-5 h-5 text-blue-500" />
                <p className="text-gotham-gray">{addCommas(target)}</p>
            </div>
            <div className="flex items-center mt-2 gap-2 px-3">
                <div className="relative flex-grow h-2 bg-titanium-white rounded-md">
                    <div
                        className="h-full rounded-md"
                        style={{
                            width: `${Math.min(percentage, 100)}%`,
                            backgroundImage: 'linear-gradient(270deg, #0F7C0F 0%, #1FAB1F 100.52%)',
                        }}
                    ></div>
                </div>
                <p className="text-sm text-gotham-gray font-bold">{`${percentage.toFixed(0)}%`}</p>
            </div>
            <div className='flex items-center justify-end mt-2 px-3 text-xs text-gotham-gray'>{otherInfo}</div>
        </div>
    );
};

export default SummaryCard;
